import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import withAuth from '../../withAuth';

import PortalLayout from "../../layout/portal-layout";
import VolunteerApplicationTable from "./volunteer-application-table";

import {fetchEnhanced} from "../../services/connection-utils";
import { Card, Spinner } from "react-bootstrap";
import { AutoSizer } from "react-virtualized";

class VolunteerApplications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applications: undefined,
      linesOfEducation: undefined,
      isLoading: true
    };
  }

  componentDidMount() {
    // Load volunteer applications from services
    const request = {
      method: 'GET'
    };

    const onSuccess = (response, body) => {
      if (response.status === 200) {
        this.setState({
          ...this.state,
          applications: body.applications,
          linesOfEducation: body.linesOfEducation,
          isLoading: false
        });
      } else {
        this.setState({
          ...this.state,
          applications: undefined,
          linesOfEducation: undefined,
          isLoading: false
        });
      }
    };

    const onFail = (errorType, status) => {
      console.log("Failed to load applications");

      this.setState({
        ...this.state,
        isLoading: false,
        applications: undefined,
        linesOfEducation: undefined,
      });
    };

    fetchEnhanced('/v1/volunteer/pending', request, onSuccess, onFail)
  }

  render() {
    return (
      <PortalLayout>
        <div className="container-fluid volunteer-applications-container" style={{flex: '1 1 auto', paddingBottom: "64px"}}>

          <h1 className="h3 mb-4 text-gray-800">Αιτήσεις Εθελοντών</h1>

          {
            this.state.isLoading &&
            <Spinner animation="border" role="status"/>
          }

          {
            !this.state.isLoading &&
            this.state.applications === undefined &&
            <div id={'error-view-access-denied'} className="ui negative message">
              <div className="header">
                Δυστυχώς δε μπορούμε να φορτώσουμε τη λίστα των αιτήσεων.
              </div>
              <p>Ελέγξτε τα δικαιώματα χρήσης σας και τη σύνδεση με το διακομιστή</p>
            </div>
          }

          {
            !this.state.isLoading &&
            this.state.applications !== undefined &&
            <AutoSizer>
              {({ height, width }) => (
                <Card style={{height: height, width: width}}>
                  <Card.Header>Αιτήσεις σε αναμονή</Card.Header>
                  <Card.Body>
                    <VolunteerApplicationTable applications={this.state.applications}
                                               linesOfEducation={this.state.linesOfEducation}/>
                  </Card.Body>
                </Card>
              )}
            </AutoSizer>
          }
        </div>
      </PortalLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default withAuth(withRouter(connect(mapStateToProps)(VolunteerApplications)))